<template>
  <transition name="in">
    <div class="present" ontouchmove="return false">
      <div class="body">
        <template v-if="bonusInfo.isOpen">
          <p class="tit">领取成功</p>
          <p class="desc">{{bonusInfo.type==1?'机票':'酒店'}}“满10赠1”任务已领取</p>
          <div class="info-box">
            <p class="long-tip">
              您在2022年共有<span>{{bonusInfo.orderCountFor2022}}{{bonusInfo.type==1?'次':'晚'}}</span>{{bonusInfo.type==1?'飞行':'酒店'}}次数可被累计{{bonusInfo.orderLen>10?`，可领取免费${bonusInfo.type==1?'机票':'酒店'}1${bonusInfo.type==1?'张':'次'}`:''}}
            </p>
            <ul class="combo-list">
              <li class="combo" v-for="i in 10" :key="i">
                <img class="img" v-if="bonusInfo.orderLen>=i"
                  src="//file.40017.cn/appresource/image/tin1/icon_airplane_blue.png">
                <img class="img" v-else src="//file.40017.cn/appresource/image/tin1/icon_airplane_gray.png">
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <p class="tit">温馨提示</p>
          <p class="desc">您已享2022年订单顺延特权</p>
          <div class="info-box">
            <p class="long-tip">
              您在2022年共有<span>{{bonusInfo.orderCountFor2022}}{{bonusInfo.type==1?'次':'晚'}}</span>{{bonusInfo.type==1?'飞行':'酒店'}}次数顺延到2023年“满10赠1”任务中，当前进度<span>{{bonusInfo.orderLen}}/10次</span>{{bonusInfo.orderLen>10?`，可领取免费${bonusInfo.type==1?'机票':'酒店'}1${bonusInfo.type==1?'张':'次'}`:''}}
            </p>
            <ul class="combo-list">
              <li class="combo" v-for="i in 10" :key="i">
                <img class="img" v-if="bonusInfo.orderLen>=i"
                  src="//file.40017.cn/appresource/image/tin1/icon_airplane_blue.png">
                <img class="img" v-else src="//file.40017.cn/appresource/image/tin1/icon_airplane_gray.png">
              </li>
            </ul>
          </div>
        </template>
        <p class="btn" v-if="bonusInfo.orderLen<10" @click="close">好的</p>
        <p class="btn" v-else @click="close">去领免费{{bonusInfo.type==1?'机票':'酒店'}}</p>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ['info'],
  computed: {
    bonusInfo() {
      return JSON.parse(this.info || '{}')
    }
  },
  methods: {
    close() {
      this.$emit('close', this.bonusInfo.isOpen)
    }
  }
}
</script>
<style scoped lang="less">
.present {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9998;
  .body {
    width: 300px;
    background-color: #fff;
    padding-bottom: 25px;
    background-image: linear-gradient(179deg, #cce8ff 0%, rgba(204, 232, 255, 0) 234px);
    border-radius: 4px;
    overflow: hidden;
    text-align: center;
    -webkit-transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    .tit {
      color: #333;
      font-size: 18px;
      font-weight: bold;
      line-height: 25px;
      padding-top: 20px;
    }
    .desc {
      font-size: 14px;
      color: #82848c;
      line-height: 20px;
      padding: 10px 28px 0;
    }
    .info-box {
      width: 260px;
      background: #fff;
      box-shadow: 0 6px 16px 0 rgba(97, 165, 223, 0.24);
      border-radius: 2px;
      margin: 15px auto 0;
      .long-tip {
        font-size: 12px;
        color: #37383d;
        line-height: 17px;
        padding: 14px 15px 0;
        span {
          font-weight: bold;
          color: #247bff;
        }
      }
      .combo-list {
        padding-left: 10px;
        padding-top: 4px;
        padding-bottom: 16px;
        text-align: left;
        .combo {
          display: inline-block;
          vertical-align: top;
          margin-left: 10px;
          margin-top: 10px;
          .img {
            width: 36px;
            height: 41px;
          }
        }
      }
    }
    .btn {
      width: 230px;
      height: 44px;
      line-height: 45px;
      color: #fff;
      background: #247bff;
      border-radius: 4px;
      margin: 33px auto 0;
    }
  }
}

.in-enter,
.in-leave-to {
  opacity: 0;
}

.in-enter-active,
.in-leave-active {
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;
}
</style>